<template>
  <data-table
    data-cy="wells-data-table"
    auto-layout
    :value="wellResults?.wells || []"
    :loading="Boolean(!wellResults?.wells)"
    :lazy="true"
    :paginator="true"
    :rows="advancedSearchItems.itemsPerPage.value"
    :rows-per-page-options="[5, 10, 20, 100]"
    :total-records="wellResults?.wells_aggregate.aggregate.count"
    :first="
      advancedSearchItems.itemsPerPage.value *
      advancedSearchItems.itemsPageNum.value
    "
    paginator-position="bottom"
    paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
    responsive-layout="scroll"
    current-page-report-template="Showing {first} to {last} of {totalRecords}"
    @sort="advancedSearchItems.handleSort"
    @page="$emit('page-change', $event)"
  >
   <template #empty>
      <p class="text-center" data-cy="no-wells-found">No wells found.</p>
    </template>
    <column field="well_name" header="Well Name" :sortable="true">
      <template #body="{ data }">
        <router-link :to="{ name: 'Well', params: { well: data.id } }" data-cy="well-name-link">
          {{ data.well_name || "Untitled" }}
        </router-link>
      </template>
    </column>
    <column field="well_uwi" header="UWI" :sortable="true">
      <template #body="{ data }">
        <span data-cy="well-uwi-text">{{ data.well_uwi || "Untitled" }}</span>
      </template>
    </column>
    <column field="sizings[0]" header="Latest Sizing">
      <template #body="{ data }">
        <router-link
          v-if="data.sizings?.[0]?.id"
          :to="{ name: 'Sizing', params: { sizingId: data.sizings[0].id } }"
          data-cy="latest-sizing-link"
        >
          {{ data.sizings?.[0]?.title || "Untitled" }}
        </router-link>
        <span v-else>N/A</span>
      </template>
    </column>
  </data-table>
</template>
<script setup lang="ts">
import { ref } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

const props = defineProps<{
  advancedSearchItems: Record<string, any>;
  page: string;
  filterSizingsBool: boolean;
}>();

const emit = defineEmits<{
  (event: 'page-change', payload: { page: number; rows: number }): void;
}>();

const wellResults = ref(props.advancedSearchItems.allWellsResults);
const itemsPerPage = ref(20);
const itemsPageNum = ref(0);

const { advancedSearchItems } = props;
</script>